import { Ref, ref } from "@vue/composition-api";

const normalize_var_name = (name: string) => {
  if (!name) return "";
  return name.startsWith("--") ? name : "--" + name;
};

export const UseCssVar = (name: string) => {
  name = normalize_var_name(name);
  const val = getComputedStyle(document.documentElement).getPropertyValue(name);
  return val ? val.trimStart() : val;
};

export const UseCssVars = (...names: string[]) => names.map(UseCssVar);

export const UseCssVarRef = (() => {
  const vars_map: Map<string, Ref<string>> = new Map();
  return function get_css_var_ref(name: string) {
    name = normalize_var_name(name);
    if (vars_map.has(name)) {
      return vars_map.get(name) as Ref<string>;
    }
    const var_ref = ref(UseCssVar(name));
    vars_map.set(name, var_ref);
    return var_ref;
  };
})();

export const UseCssVarRefs = (...names: string[]) => names.map(UseCssVarRef);
